import styled from 'styled-components';
import { Link } from 'react-router-dom';

// The whole card is a real anchor so native browser affordances work
// (Ctrl/Cmd+click, middle-click and right-click all open the record in a new tab)
// and it is keyboard-focusable. A primary tint on hover reads as interactive without
// blending into the grey page behind the white card.
export const ItemContainer = styled(Link)`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.common.white};
  box-shadow: ${({ theme }) => theme.shadows.card};
  margin-bottom: 8px;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${({ theme }) => theme.tint.primary.light};
  }
`;

export const UnreadDot = styled.div<{ $visible: boolean }>`
  width: 10px;
  height: 10px;
  min-width: 10px;
  border-radius: 50%;
  background-color: ${({ $visible, theme }) => ($visible ? theme.palette.primary.main : 'transparent')};
  margin-top: 11px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TimeText = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
`;

// A due-today reminder has no human actor, so a clock sits where the avatar would.
// Dimensions match the 32px avatar so the row stays pixel-aligned with normal notifications.
export const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.tint.primary.light};
  color: ${({ theme }) => theme.palette.primary.main};
`;
